// Module
var code = "<i class=\"glyphicon glyphicon-question-sign\" tooltip={{description}}></i>";
// Exports
module.exports = code;